var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.externalId'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.externalId,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "externalId", $$v);
      },
      expression: "value.externalId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('report.policeDetails.isPolicy'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.policeDetails.isRecorded,
      callback: function callback($$v) {
        _vm.$set(_vm.policeDetails, "isRecorded", $$v);
      },
      expression: "policeDetails.isRecorded"
    }
  })], 1), _vm.policeDetails.isRecorded ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.policeDetails.department'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.policeDetails.department,
      callback: function callback($$v) {
        _vm.$set(_vm.policeDetails, "department", $$v);
      },
      expression: "policeDetails.department"
    }
  })], 1) : _vm._e(), _vm.policeDetails.isRecorded ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.policeDetails.fileReference'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.policeDetails.fileReference,
      callback: function callback($$v) {
        _vm.$set(_vm.policeDetails, "fileReference", $$v);
      },
      expression: "policeDetails.fileReference"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.leasingDetails.title.leasing'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.leasing.isLeasing,
      callback: function callback($$v) {
        _vm.$set(_vm.leasing, "isLeasing", $$v);
      },
      expression: "leasing.isLeasing"
    }
  })], 1), _vm.leasing.isLeasing ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.leasing.company'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.leasing.company,
      callback: function callback($$v) {
        _vm.$set(_vm.leasing, "company", $$v);
      },
      expression: "leasing.company"
    }
  })], 1) : _vm._e(), _vm.leasing.isLeasing ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.leasing.claimNumber'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.leasing.claimNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.leasing, "claimNumber", $$v);
      },
      expression: "leasing.claimNumber"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('objects.report.broker.name'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.isBroker,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isBroker", $$v);
      },
      expression: "value.isBroker"
    }
  })], 1), _vm.value.isBroker ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.broker.name'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.broker.name,
      callback: function callback($$v) {
        _vm.$set(_vm.broker, "name", $$v);
      },
      expression: "broker.name"
    }
  })], 1) : _vm._e(), _vm.value.isBroker ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.broker.number'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.broker.number,
      callback: function callback($$v) {
        _vm.$set(_vm.broker, "number", $$v);
      },
      expression: "broker.number"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('objects.report.attorney.name'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.isAttorney,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isAttorney", $$v);
      },
      expression: "value.isAttorney"
    }
  })], 1), _vm.value.isAttorney ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.attorney.name'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.attorney.name,
      callback: function callback($$v) {
        _vm.$set(_vm.attorney, "name", $$v);
      },
      expression: "attorney.name"
    }
  })], 1) : _vm._e(), _vm.value.isAttorney ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.attorney.number'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.attorney.number,
      callback: function callback($$v) {
        _vm.$set(_vm.attorney, "number", $$v);
      },
      expression: "attorney.number"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('report.insurance.title'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.isInsurance,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isInsurance", $$v);
      },
      expression: "value.isInsurance"
    }
  })], 1), _vm.value.isInsurance ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.insurances.name'),
      "rules": _vm.requiredRule,
      "hide-details": "auto"
    },
    model: {
      value: _vm.insurance.name,
      callback: function callback($$v) {
        _vm.$set(_vm.insurance, "name", $$v);
      },
      expression: "insurance.name"
    }
  })], 1) : _vm._e(), _vm.value.isInsurance ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.insurances.number'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.insurance.number,
      callback: function callback($$v) {
        _vm.$set(_vm.insurance, "number", $$v);
      },
      expression: "insurance.number"
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }